export const domainKey = 'starrysky'
// export const domainName = `www.${domainKey}.games`
// export const domainName = `www.${domainKey}.com`
export const domainName = `www.${domainKey}.mx`
// export const domainName = 'dev.leo-pp.com'
// export const domainName = 'dev.morena888.com'
// export const domainName = 'dev-brazilv5.tt-22.com'
// export const domainName = 'dev-mexico7.7777ru.com'
// export const domainName = 'dev-russ.moose888.com'
export const host = `https://${domainName}/api`
// export const host = window.location.origin + '/api' // 正式上线
// export const host = 'http://dev.rei-bet.com/api' // 测试
// export const host = "http://8.218.60.59:9202" // 测试
export const inviteCodeKey = 'inviteMemberId'
export const domain = `https://${domainName}`
export const webSocketUrl = `wss://${domainName}/api/onlineSend`
export const pn = 'm051'

// Build-time theme selection; API and tenant stay on the existing test configuration.
export const defaultThemeSkin = 'aurora'
export const showThemeSkinSelect = false
export const themeSkinOptions = [
    { label: '浅紫 AI', value: 'aurora' },
    { label: '黑灰 darkgray', value: 'darkgray' },
    { label: '紫色 purple', value: 'purple' },
    { label: '红蓝 redblue', value: 'redblue' },
    { label: '绿黑 greenblack', value: 'greenblack' }
]
